export type ProductCategory =
  | 'Complete Systems'
  | 'Bundles'
  | 'Modules'
  | 'Accessories'
export type Season =
  | 'Lawn Care'
  | 'Snow Removal'
  | 'Leaf Cleanup'
  | 'All-Season'

export interface Product {
  id: string
  slug: string
  name: string
  category: ProductCategory
  season: Season[]
  price: number
  shortDescription: string
  features: string[]
  includes: string[]
  image: string
  isPopular?: boolean
}

export const products: Product[] = [
  {
    id: 'yarbo-lawn-mower',
    slug: 'yarbo-lawn-mower',
    name: 'Yarbo Lawn Mower',
    category: 'Complete Systems',
    season: ['Lawn Care'],
    price: 4199,
    shortDescription:
      'Wire-free, multi-zone robotic lawn mower designed for Michigan yards up to 6 acres.',
    features: [
      'Smart object detection',
      'Wire-free setup with app-defined virtual boundaries',
      'Multi-zone management',
      'Mows up to 6 acres twice per week',
      'Handles slopes up to 35 degrees (70%)',
    ],
    includes: [
      'Yarbo Core',
      'Lawn Mower Module',
      'Docking Station',
      'RTK Antenna',
    ],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower.png?v=1777093280&width=1445',
  },
  {
    id: 'yarbo-lawn-mower-pro',
    slug: 'yarbo-lawn-mower-pro',
    name: 'Yarbo Lawn Mower Pro',
    category: 'Complete Systems',
    season: ['Lawn Care'],
    price: 5599,
    shortDescription:
      'High-performance mowing with dual 300W motors for demanding Michigan lawns and steep slopes.',
    features: [
      'Dual 300W motors for demanding lawns',
      '2500W peak cutting power',
      'Optional straight blades available',
      'Mows up to 6 acres',
      'Handles 70% / 35-degree slopes',
    ],
    includes: [
      'Yarbo Core',
      'Lawn Mower Pro Module',
      'Docking Station',
      'RTK Antenna',
    ],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower_Pro.png?v=1777093280&width=1445',
    isPopular: true,
  },
  {
    id: 'yarbo-snow-blower',
    slug: 'yarbo-snow-blower',
    name: 'Yarbo Snow Blower',
    category: 'Complete Systems',
    season: ['Snow Removal'],
    price: 4999,
    shortDescription:
      'Autonomous 2-stage snow clearing built for serious Michigan winter conditions.',
    features: [
      'Autonomous snow clearing',
      '2-stage snow blower design',
      'Clears up to 12 inches of snow',
      '24-inch clearing width',
      'Auto recharge and resume functionality',
    ],
    includes: [
      'Yarbo Core',
      'Snow Blower Module',
      'Docking Station',
      'RTK Antenna',
    ],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Snow_Blower.png?v=1777093280&width=1445',
    isPopular: true,
  },
  {
    id: 'yarbo-blower',
    slug: 'yarbo-blower',
    name: 'Yarbo Blower',
    category: 'Complete Systems',
    season: ['Leaf Cleanup'],
    price: 4799,
    shortDescription:
      'Robotic leaf and debris clearing with 21 N blowing force for wooded properties.',
    features: [
      'Robotic leaf and debris clearing',
      '21 N blowing force',
      'Handles slopes up to 35 degrees (70%)',
      '70-minute continuous runtime per charge',
      'App-controlled clearing zones',
    ],
    includes: ['Yarbo Core', 'Blower Module', 'Docking Station', 'RTK Antenna'],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Blower.png?v=1777093280&width=1445',
  },
  {
    id: 'yarbo-trimmer-module',
    slug: 'yarbo-trimmer-module',
    name: 'Trimmer Module (Y Series)',
    category: 'Modules',
    season: ['Lawn Care'],
    price: 799,
    shortDescription:
      'Hands-free edge trimming module that connects to your Yarbo Core.',
    features: [
      'Connects through Back Brace Mount (BBM)',
      'Automatic line feed',
      'Hands-free trimming',
      'Adjustable trimming height (2–4 inches)',
    ],
    includes: ['Yarbo Trimmer', 'Back Brace Mount'],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Trimmer_Package.png?v=1777093279&width=1445',
  },
  {
    id: 'yarbo-all-season-pro-bundle',
    slug: 'yarbo-all-season-pro-bundle',
    name: 'Yarbo Lawn Mower Pro + Snow Blower + Blower',
    category: 'Bundles',
    season: ['All-Season'],
    price: 7499,
    shortDescription:
      'The ultimate all-season Michigan yard care system. One Core, three powerful modules.',
    features: [
      'Complete year-round yard maintenance',
      'Pro-level mowing power',
      '2-stage snow clearing',
      'High-force leaf blowing',
      'Seamless module swapping',
    ],
    includes: [
      'Yarbo Core',
      'Lawn Mower Pro Module',
      'Snow Blower Module',
      'Blower Module',
      'Docking Station',
      'RTK Antenna',
    ],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_4-in-1_Yard_Robot_with_Lawn_Mower_Pro_Module.png?v=1777093281&width=1445',
    isPopular: true,
  },
  {
    id: 'yarbo-lawn-mower-pro-snow-blower',
    slug: 'yarbo-lawn-mower-pro-snow-blower',
    name: 'Yarbo Lawn Mower Pro + Snow Blower',
    category: 'Bundles',
    season: ['Lawn Care', 'Snow Removal'],
    price: 6699,
    shortDescription:
      "Dual-season bundle tackling Michigan's toughest lawns and heaviest snowfalls.",
    features: [
      'Dual 300W mowing motors',
      '2-stage snow clearing',
      'Handles steep slopes',
      'Auto recharge and resume',
    ],
    includes: [
      'Yarbo Core',
      'Lawn Mower Pro Module',
      'Snow Blower Module',
      'Docking Station',
    ],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower_Pro.png?v=1777093280&width=1445',
  },
  {
    id: 'yarbo-snow-blower-blower',
    slug: 'yarbo-snow-blower-blower',
    name: 'Yarbo Snow Blower + Blower',
    category: 'Bundles',
    season: ['Snow Removal', 'Leaf Cleanup'],
    price: 5999,
    shortDescription:
      'Winter and fall bundle for snow clearing and leaf management.',
    features: [
      '2-stage snow clearing',
      '21 N blowing force',
      'Perfect for wooded lots with long driveways',
    ],
    includes: [
      'Yarbo Core',
      'Snow Blower Module',
      'Blower Module',
      'Docking Station',
    ],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Snow_Blower.png?v=1777093280&width=1445',
  },
  {
    id: 'yarbo-lawn-mower-snow-blower',
    slug: 'yarbo-lawn-mower-snow-blower',
    name: 'Yarbo Lawn Mower + Snow Blower',
    category: 'Bundles',
    season: ['Lawn Care', 'Snow Removal'],
    price: 5199,
    shortDescription:
      'Standard dual-season bundle for year-round property maintenance.',
    features: [
      'Wire-free mowing up to 6 acres',
      '2-stage snow clearing',
      'App-controlled scheduling',
    ],
    includes: [
      'Yarbo Core',
      'Lawn Mower Module',
      'Snow Blower Module',
      'Docking Station',
    ],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower.png?v=1777093280&width=1445',
  },
  {
    id: 'yarbo-lawn-mower-blower',
    slug: 'yarbo-lawn-mower-blower',
    name: 'Yarbo Lawn Mower + Blower',
    category: 'Bundles',
    season: ['Lawn Care', 'Leaf Cleanup'],
    price: 4999,
    shortDescription:
      'Spring through fall maintenance bundle for mowing and leaf clearing.',
    features: [
      'Wire-free mowing',
      '21 N blowing force',
      'Multi-zone management',
    ],
    includes: [
      'Yarbo Core',
      'Lawn Mower Module',
      'Blower Module',
      'Docking Station',
    ],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower.png?v=1777093280&width=1445',
  },
  {
    id: 'yarbo-lawn-mower-pro-blower',
    slug: 'yarbo-lawn-mower-pro-blower',
    name: 'Yarbo Lawn Mower Pro + Blower',
    category: 'Bundles',
    season: ['Lawn Care', 'Leaf Cleanup'],
    price: 6499,
    shortDescription:
      'High-performance mowing and leaf clearing for demanding properties.',
    features: [
      'Dual 300W mowing motors',
      '21 N blowing force',
      'Handles steep slopes up to 70%',
    ],
    includes: [
      'Yarbo Core',
      'Lawn Mower Pro Module',
      'Blower Module',
      'Docking Station',
    ],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower_Pro.png?v=1777093280&width=1445',
  },
  {
    id: 'lawn-mower-module',
    slug: 'lawn-mower-module',
    name: 'Lawn Mower Module (Y Series)',
    category: 'Modules',
    season: ['Lawn Care'],
    price: 1199,
    shortDescription:
      'Add standard mowing capabilities to your existing Yarbo Core.',
    features: [
      'Requires Yarbo Core',
      'Multi-zone management',
      'Wire-free setup',
    ],
    includes: ['Lawn Mower Module Only'],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower.png?v=1777093280&width=1445',
  },
  {
    id: 'snow-blower-module',
    slug: 'snow-blower-module',
    name: 'Snow Blower Module (Y Series)',
    category: 'Modules',
    season: ['Snow Removal'],
    price: 1999,
    shortDescription:
      'Add 2-stage snow clearing capabilities to your existing Yarbo Core.',
    features: [
      'Requires Yarbo Core',
      '2-stage design',
      '24-inch clearing width',
    ],
    includes: ['Snow Blower Module Only'],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Snow_Blower.png?v=1777093280&width=1445',
  },
  {
    id: 'lawn-mower-pro-module',
    slug: 'lawn-mower-pro-module',
    name: 'Lawn Mower Pro Module (Y Series)',
    category: 'Modules',
    season: ['Lawn Care'],
    price: 2599,
    shortDescription:
      'Upgrade your Yarbo Core with high-performance dual-motor mowing.',
    features: [
      'Requires Yarbo Core',
      'Dual 300W motors',
      '2500W peak cutting power',
    ],
    includes: ['Lawn Mower Pro Module Only'],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Lawn_Mower_Pro.png?v=1777093280&width=1445',
  },
  {
    id: 'blower-module',
    slug: 'blower-module',
    name: 'Blower Module (Y Series)',
    category: 'Modules',
    season: ['Leaf Cleanup'],
    price: 1799,
    shortDescription:
      'Add powerful leaf and debris clearing to your existing Yarbo Core.',
    features: [
      'Requires Yarbo Core',
      '21 N blowing force',
      'App-controlled zones',
    ],
    includes: ['Blower Module Only'],
    image:
      'https://www.yarbo.com/cdn/shop/files/Yarbo_Blower.png?v=1777093280&width=1445',
  },
]

export const getProductBySlug = (slug: string) =>
  products.find((p) => p.slug === slug)
export const getProductsByCategory = (category: ProductCategory) =>
  products.filter((p) => p.category === category)
export const getProductsBySeason = (season: Season) =>
  products.filter(
    (p) => p.season.includes(season) || p.season.includes('All-Season'),
  )
export const getPopularProducts = () => products.filter((p) => p.isPopular)
